/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const mutateAddFileClientIdMax = 36;

export const mutateAddFileClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');

export const MutateAddFile = zod.object({
  clientId: zod
    .string()
    .min(1)
    .max(mutateAddFileClientIdMax)
    .regex(mutateAddFileClientIdRegExp)
    .describe(
      'Caller-supplied reference for a node added in THIS request, unique within it. Wires edges to not-yet-persisted nodes and keys the response’s clientIdMap. Lowercase letters, numbers, and ._:- only.',
    ),
  fileUuid: zod.uuid().describe('UUID v4 identifier'),
  occurredAt: zod.iso.datetime({ offset: true }).optional(),
  subjectUuid: zod.uuid().nullish().describe('UUID v4 identifier'),
});

export type MutateAddFile = zod.input<typeof MutateAddFile>;
export type MutateAddFileOutput = zod.output<typeof MutateAddFile>;
